import { render } from "./EdStatuses.vue?vue&type=template&id=9b38416c"
import script from "./EdStatuses.vue?vue&type=script&lang=js"
export * from "./EdStatuses.vue?vue&type=script&lang=js"

import "./EdStatuses.vue?vue&type=style&index=0&id=9b38416c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__